module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8627/img/design-manager.svg"